<template>
  <div id='right-panel' :class="tripType">
    <div class="rightTop" :class="{'oneDest': !hasDestinations}">
      <a href="#" class="animated"  v-if="!galleryActive && currentDest">
        <div><img class="close-btn" src="../assets/times.png"  @click.prevent="closeRightPanel()"></div>
        <div @click.prevent="openGallery()" class="imgWrap" :style="{ backgroundImage: 'url(' + bgImg + ')' }"></div>
      </a>
      <div class="destCont" :class="{'galActive': galleryActive}">
        
        <div  @click.prevent="openGallery()" v-if="!galleryActive" class="gallery-button">View Gallery <div class="fa fa-external-link open-gallery-icon"></div></div>

<!--         <div class="destSocial" v-if="trip">
          <a v-if="hasFacebook" :href="trip.acf.facebook_link"><i class="fa fa-facebook" aria-hidden="true"></i></a>
          <a v-if="hasTwitter" :href="trip.acf.twitter_link"><i class="fa fa-twitter" aria-hidden="true"></i></a>
          <p v-if="hasFacebook || hasTwitter">follow this trip</p>
        </div> -->
        <h1>{{currentDest.title}}</h1>
        <div v-html="currentDest.content"></div>
      </div>
    </div>
    <!-- <a href="#" @click.prevent="openGallery()">Open Gallery</a> -->
    <div class="rightBtm" :class="tripType" v-if="hasDestinations"><span><a href="#" @click.prevent="prevDest()"><i class="fa fa-chevron-left" aria-hidden="true"></i></a>explore<a href="#" @click.prevent="nextDest()"><i class="fa fa-chevron-right" aria-hidden="true"></i></a></span></div>
  </div>
</template>
<script>
// var fontAwesome = require('font-awesome-webpack')
// var _ = require('lodash')
import _ from 'lodash'
import { mapActions, mapState } from 'vuex'
import router from '@/router'

// import {
//     closeRightPanel,
//     openGallery,
//     setCurrentDest
//   } from '@/vuex/actions'

export default {
  // vuex: {
  //   getters: {
  //     active: state => state.rightPanelActive,
  //     trip: state => state.currentTrip,
  //     galleryActive: state => state.galleryActive,
  //     currentDest: state => state.currentDest
  //   },
  //   actions: {
  //     closeRightPanel,
  //     setCurrentDest,
  //     openGallery
  //   }
  // },
  props: ['trip'],
  computed: {
    ...mapState({
      galleryActive: state => state.galleryActive,
      currentDest: state => state.currentDest
    }),
    tripType () {
      if (!_.hasIn(this.trip, 'types')) { return }
      if (this.trip.types.indexOf('future-trips') !== -1) {
        return 'future-trips'
      } else if (this.trip.types.indexOf('faculty-led') !== -1) {
        return 'faculty-led'
      } else {
        return 'student-trip'
      }
    },
    hasDestinations () {
      if (!_.hasIn(this.trip, 'acf.destinations')) { return }
      return this.trip.acf.destinations.length > 1
    },
    hasFacebook () {
      return (_.hasIn(this.trip, 'acf.facebook_link') && this.trip.acf.facebook_link)
    },
    hasTwitter () {
      return _.hasIn(this.trip, 'acf.twitter_link')
    },
    bgImg () {
      if (!_.hasIn(this.currentDest, 'gallery')) { return }
      return this.currentDest.gallery[0].sizes.panelImage
    }
  },
  methods: {
    ...mapActions([
      'setCurrentDest',
      'openGallery'
    ]),
    closeRightPanel () {
      router.push({ name: 'Home' })
    },
    nextDest: function (trip) {
      var dests = this.trip.acf.destinations
      var destLength = this.trip.acf.destinations.length - 1
      var index = dests.indexOf(this.currentDest)
      if (index >= 0 && index < destLength) {
        this.setCurrentDest(dests[index + 1])
      }
      if (index === destLength) {
        this.setCurrentDest(dests[0])
      }
    },
    prevDest: function (trip) {
      var dests = this.trip.acf.destinations
      var destLength = this.trip.acf.destinations.length - 1
      var index = dests.indexOf(this.currentDest)
      if (index > 0 && index <= destLength) {
        this.setCurrentDest(dests[index - 1])
      }
      if (index === 0) {
        this.setCurrentDest(dests[destLength])
      }
    }
  }
}
</script>
<style>
  #right-panel {
    bottom: 0; 
    right: 0;
    top: 0;
    height: calc(100% - 60px);
    width: 35%;
    position: absolute;
    z-index: 9999;
    background-color: #043969;
    transition: all .5s ease;
    color: #fff;
    box-sizing: border-box;
  }
  #right-panel.future-trips, .rightBtm.future-trips {
    background-color: #5C5C5C;
  }
  #right-panel.student-trip, .rightBtm.student-trip {
    background-color: #003DA7;
  }
  #right-panel h1 {
    clear:both;
    padding:0;
    font-size:2.4em;
    margin-top:0;
  }
  .close-btn {
    position: absolute;
    right: 0;
    top:10px;
    margin: 6px 20px 10px -35px;
    width:20px;
  }
  .imgWrap {
    height:33%;
    width:100%;
    background-repeat:no-repeat;
    background-size:cover;
    background-position:center;
  }
  .destCont {
    padding: .75em 2.5em;
    padding-bottom:72px;
    line-height:1.4;
    box-sizing:border-box;
    position: relative;
    text-align: left;
    font-weight: 700;
  }
  .destCont a:link, .destCont a:visited {
    color:#fff;
  }
  .destSocial {
    text-align:center;
    float:left;
    margin-top: 10px;
  }
  .destSocial a:link, .destSocial a:visited {
    color:#fff;
    font-size:1.25em;
  }
  .destSocial a:first-child {
    margin-right:10px;
  }
  .destSocial a:last-child {
    margin-left:10px;
  }
  .destSocial p {
    font-size:.625em;
    margin-bottom:0;
  }
  .rightTop {
    overflow-y:scroll;
    height:calc(100% - 48px);
  }
  .rightTop.oneDest {
    height:100%;
  }
  .rightBtm {
    position:fixed;
    bottom:60px;
    width:35%;
    background-color:#043969;
    padding:.75em 1.5em .25em;
    box-sizing:border-box;
    text-align:center;
  }

  .rightBtm a:link, .rightBtm a:visited {
    color:#fff;
    text-decoration:none;
    margin:0 .5em;
    font-size:1.75em;
    vertical-align: middle;
  }
  .open-gallery-icon {
    color: #fff;
    /*background-color:rgba(4,57,105,.8);*/
    /*padding: 7px 7px 5px 10px;*/
    margin-left: 10px;
    /*border-radius: 5px;*/
    font-size: 24px;
  }

  .gallery-button {
    cursor: pointer;
    position: absolute;
    right: 20px;
    top: 10px;
    font-size: .8rem;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  @media (max-width : 769px) {
    #right-panel h1 {
      font-size:1.5em;
    }
    #right-panel {
      bottom: 60px;
    }
    .rightTop {
      overflow-y:initial;
    }
    .destCont {
      overflow-y:scroll;
      height:100%;
      padding-bottom:10px;
    }
    .rightTop .destCont.galActive {
      width:100%;
      float:none;
    }
    .rightBtm {
      position:absolute;
      bottom:0;
    }
    .close-btn {
      margin:6px 20px 10px -30px;
    }
  }
  @media (max-width : 769px) and (orientation: portrait) {
    #right-panel {
      right:0;
      bottom:-45%;
      top:inherit;
      width:100%;
      height:45%;
    }
    .rightTop {
      height: calc(100% - 40px);
    }
    .rightTop .animated {
      float:left;
      width:35%;
      height:100%;
      display:block;
      position:relative;
    }
    .rightTop .destCont {
      float:left;
      width:65%;
      box-sizing: border-box;
      font-size:.825em;
    }
    .rightTop .imgWrap {
      height:100%;
    }
    .rightBtm {
      width:100%;
      font-size:.875em;
    }
    .rightBtm a:link, .rightBtm a:visited {
      margin:0 1em;
    }
  }
  @media (max-width : 769px) and (orientation: landscape) {
    #right-panel {
      height:calc(100% - 35px);
    }
    .rightTop .destCont {
      font-size:.825em;
      box-sizing:border-box;
    }
    .rightBtm {
      font-size:.825em;
      width:100%;
    }
  }
</style>



// WEBPACK FOOTER //
// RightPanel.vue?285c48bf